export const VerificationStatuses = {
  NOT_SUBMITTED: 'businessVerificationNotSubmitted',
  PENDING: 'businessVerificationPending',
  DENIED: 'businessVerificationDenied',
  FAILED: 'businessVerificationFailed',
  VERIFIED: 'businessVerified',
} as const

export type VerificationRequestStatus =
  (typeof VerificationStatuses)[keyof typeof VerificationStatuses]

export const OnboardingVerificationStatuses: VerificationRequestStatus[] = [
  VerificationStatuses.NOT_SUBMITTED,
  VerificationStatuses.PENDING,
] as const

export const RejectedVerificationStatuses: VerificationRequestStatus[] = [
  VerificationStatuses.DENIED,
  VerificationStatuses.FAILED,
] as const

export interface CountryOptions {
  value: string
  label: string
}

export interface DocumentUpload {
  id?: number
  buffer: string | ArrayBuffer
  documentType?: string
  description?: string
  fileData: File
  path?: string
}

export const VerificationResult = {
  SUCCESS: 'success',
  FAILURE: 'failure',
  DECLINED: 'declined',
} as const

export type VerificationResult = (typeof VerificationResult)[keyof typeof VerificationResult]
